import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { FinanceCashFlows } from "@/types";
import { httpRequest } from "@/lib";
import { formatDateToBackend } from "@/utils";

type Props = {
  page: string | null;
  per_page?: number | null;
  startDate: string;
  endDate: string;
};

async function fetchFinanceCashFlowByRangeDate({
  page,
  per_page,
  endDate,
  startDate,
}: Props): Promise<FinanceCashFlows> {
  const response = await httpRequest.get<FinanceCashFlows>(
    `/entries/get-by-period?start_date=${formatDateToBackend(
      startDate
    )}&end_date=${formatDateToBackend(endDate)}&page=${page || 1}&per_page=${
      per_page || 10
    }`
  );
  return response.data;
}

export function useFetchFinanceCashFlowByRangeDateMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchFinanceCashFlowByRangeDate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["entries"] });
    },
  });
}
